import { render, staticRenderFns } from "./MitManageBuildingsPage.vue?vue&type=template&id=b202e25a&scoped=true"
import script from "./MitManageBuildingsPage.vue?vue&type=script&lang=js"
export * from "./MitManageBuildingsPage.vue?vue&type=script&lang=js"
import style0 from "./MitManageBuildingsPage.vue?vue&type=style&index=0&id=b202e25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b202e25a",
  null
  
)

export default component.exports